import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-devops-transformation',
  templateUrl: './devops-transformation.component.html',
  styleUrls: ['./devops-transformation.component.sass']
})
export class DevopsTransformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
